var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('base-form',{staticClass:"user__form"},[_c('base-card',{staticClass:"user__details",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("global.details"))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"user__body display--grid page--single__grid"},[_c('base-field',{staticClass:"user__body__name",attrs:{"settings":{
                            label: {
                                class: 'capitalize',
                                text: _vm.$t('global.name'),
                            },
                            input: {
                                component: 'InputBasic',
                                id: 'name',
                                name: 'name',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.model.name,
                                browserAutocomplete: 'name',
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.name,
                                errorOnSubmit: {
                                    show: _vm.errors.api.name ? true : false,
                                    messages: _vm.errors.api.name,
                                },
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling:
                                _vm.permissions.allowFilling ||
                                _vm.$store.getters.isSameUser(_vm.model.id),
                        }}}),_c('base-field',{staticClass:"user__body__nif",attrs:{"settings":{
                            label: {
                                class: 'capitalize',
                                text: _vm.$t(
                                    'global.taxpayerIdentificationNumber'
                                ),
                            },
                            input: {
                                component: 'InputBasic',
                                id: 'taxpayerIdentificationNumber',
                                name: 'taxpayerIdentificationNumber',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.model.taxpayerIdentificationNumber,
                                browserAutocomplete:
                                    'taxpayerIdentificationNumber',
                                fileValidation: 'nif',
                                errors: [
                                    {
                                        type: 'validateNIF',
                                        warning: _vm.$t('error.nif'),
                                    } ],
                                errorOnSubmit: {
                                    show: _vm.errors.api
                                        .taxpayerIdentificationNumber
                                        ? true
                                        : false,
                                    messages:
                                        _vm.errors.api
                                            .taxpayerIdentificationNumber,
                                },
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling:
                                _vm.permissions.allowFilling ||
                                _vm.$store.getters.isSameUser(_vm.model.id),
                        }}}),_c('base-field',{staticClass:"user__body__cc",attrs:{"settings":{
                            label: {
                                class: 'capitalize',
                                text: _vm.$t(
                                    'global.nationalIdentificationNumber'
                                ),
                            },
                            input: {
                                component: 'InputBasic',
                                id: 'nationalIdentificationNumber',
                                name: 'nationalIdentificationNumber',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.model.nationalIdentificationNumber,
                                browserAutocomplete:
                                    'nationalIdentificationNumber',
                                errorOnSubmit: {
                                    show: _vm.errors.api
                                        .nationalIdentificationNumber
                                        ? true
                                        : false,
                                    messages:
                                        _vm.errors.api
                                            .nationalIdentificationNumber,
                                },
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling:
                                _vm.permissions.allowFilling ||
                                _vm.$store.getters.isSameUser(_vm.model.id),
                        }}}),_c('base-field',{staticClass:"user__body__extension",attrs:{"settings":{
                            label: {
                                class: 'capitalize',
                                text: _vm.$t(
                                    'global.freeswitchExtension'
                                ),
                            },
                            input: {
                                component: 'InputBasic',
                                id: 'freeswitchExtension',
                                name: 'freeswitchExtension',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.model.extension
                            }
                        }}}),_c('base-field',{staticClass:"user__body__state",attrs:{"settings":{
                            label: {
                                class: 'capitalize',
                                text: _vm.$t('global.state'),
                            },
                            input: {
                                component: 'States',
                                name: 'state',
                                value: _vm.stateId,
                                dynamicData: {
                                    states: [1, 2],
                                },
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling:
                                _vm.isEdition && _vm.permissions.allowFilling,
                        }}})],1)]},proxy:true}])}),_c('div',{staticClass:"user__cols display--grid page--single__half"},[_c('base-card',{staticClass:"user__contacts",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("global.contacts"))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"user__body display--grid page--single__half"},[_c('base-field',{staticClass:"user__body__address",attrs:{"settings":{
                                label: {
                                    class: 'capitalize',
                                    text: _vm.$t('global.address'),
                                },
                                input: {
                                    component: 'InputBasic',
                                    id: 'address',
                                    name: 'address',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.address,
                                    browserAutocomplete: 'address',
                                    errorOnSubmit: {
                                        show: _vm.errors.api.address
                                            ? true
                                            : false,
                                        messages: _vm.errors.api.address,
                                    },
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling:
                                    _vm.permissions.allowFilling ||
                                    _vm.$store.getters.isSameUser(_vm.model.id),
                            }}}),_c('base-field',{staticClass:"user__body__email",attrs:{"settings":{
                                label: {
                                    class: 'capitalize',
                                    text: _vm.$t('global.email'),
                                },
                                input: {
                                    component: 'InputBasic',
                                    id: 'email',
                                    name: 'email',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.model.email,
                                    browserAutocomplete: 'email',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.email,
                                    fileValidation: 'basicEmail',
                                    errors: [
                                        {
                                            type: 'email',
                                            warning: _vm.$t('error.email'),
                                        } ],
                                    errorOnSubmit: {
                                        show: _vm.errors.api.email
                                            ? true
                                            : false,
                                        messages: _vm.errors.api.email,
                                    },
                                },
                                isEdition: _vm.isEdition,
                                allowFilling:
                                    !_vm.isEdition && _vm.permissions.allowFilling,
                            }}}),_c('base-field',{staticClass:"user__body__mobile",attrs:{"settings":{
                                label: {
                                    class: 'capitalize',
                                    text: _vm.$t('global.mobile'),
                                },
                                input: {
                                    component: 'InputBasic',
                                    id: 'mobile',
                                    name: 'mobile',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.mobile,
                                    browserAutocomplete: 'mobile',
                                    errorOnSubmit: {
                                        show: _vm.errors.api.mobile
                                            ? true
                                            : false,
                                        messages: _vm.errors.api.mobile,
                                    },
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling:
                                    _vm.permissions.allowFilling ||
                                    _vm.$store.getters.isSameUser(_vm.model.id),
                            }}}),_c('base-field',{staticClass:"user__body__phone",attrs:{"settings":{
                                label: {
                                    class: 'capitalize',
                                    text: _vm.$t('global.phone'),
                                },
                                input: {
                                    component: 'InputBasic',
                                    id: 'phone',
                                    name: 'phone',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: _vm.phone,
                                    browserAutocomplete: 'phone',
                                    errorOnSubmit: {
                                        show: _vm.errors.api.phone
                                            ? true
                                            : false,
                                        messages: _vm.errors.api.phone,
                                    },
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling:
                                    _vm.permissions.allowFilling ||
                                    _vm.$store.getters.isSameUser(_vm.model.id),
                            }}})],1)]},proxy:true}])}),_c('base-card',{staticClass:"user__associations",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("global.associations"))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"user__body"},[_c('base-field',{staticClass:"user__body__role",attrs:{"settings":{
                                label: {
                                    class: 'capitalize',
                                    text: _vm.$t('global.role'),
                                },
                                input: {
                                    component: 'InputAutocomplete',
                                    id: 'roleId',
                                    name: 'roleId',
                                    type: 'text',
                                    value: _vm.role.id,
                                    targetClass:
                                        'field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.roleId,
                                    dynamicData: {
                                        data: [
                                            {
                                                value: 2,
                                                label: _vm.$t('roles.admin'),
                                            },
                                            {
                                                value: 5,
                                                label: _vm.$t('roles.auditor'),
                                            },
                                            {
                                                value: 6,
                                                label: _vm.$t('roles.administrativeAuditor'),
                                            },
                                            {
                                                value: 4,
                                                label: _vm.$t('roles.operator'),
                                            },
                                            {
                                                value: 3,
                                                label: _vm.$t(
                                                    'roles.supervisor'
                                                ),
                                            } ],
                                        apiValue: {
                                            value: _vm.role.id,
                                            label: _vm.role.label
                                                ? _vm.$t(("roles." + (_vm.role.label)))
                                                : '',
                                        },
                                    },
                                    errorOnSubmit: {
                                        show: _vm.errors.api.roleId
                                            ? true
                                            : false,
                                        messages: _vm.errors.api.roleId,
                                    },
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: _vm.permissions.allowFilling,
                            }}}),_c('base-field-with-url',{staticClass:"user__body__parent",attrs:{"fieldClass":"user__body__parent__field","settings":{
                                label: {
                                    class: 'capitalize',
                                    text: _vm.$t('global.responsible'),
                                },
                                input: {
                                    component: 'InputAutocomplete',
                                    id: 'parentId',
                                    name: 'parentId',
                                    type: 'text',
                                    value: _vm.parent.id,
                                    targetClass:
                                        'field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.parentIsRequired,
                                    isMissing: _vm.errors.missing.parentId,
                                    dynamicData: {
                                        data: [].concat( _vm.users ),
                                        ordering: _vm.order.loading,
                                        apiValue: {
                                            label: _vm.parent.name,
                                            value: _vm.parent.id,
                                        },
                                    },
                                    errorOnSubmit: {
                                        show: _vm.errors.api.parentId
                                            ? true
                                            : false,
                                        messages: _vm.errors.api.parentId,
                                    },
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: _vm.permissions.allowFilling,
                            },"anchor":{
                                url: ("/users/" + _vm.parentId),
                                disable: !_vm.parentId,
                                see: !_vm.$store.getters.isSameUser(_vm.model.id),
                                translationKey: 'viewProfile'
                            }}}),_c('base-field-with-url',{staticClass:"user__body__client",attrs:{"settings":{
                                label: {
                                    class: 'capitalize',
                                    text: _vm.$t('global.client'),
                                },
                                input: {
                                    component: 'InputAutocomplete',
                                    id: 'clientId',
                                    type: 'text',
                                    targetClass:
                                        'field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.clientIsRequired,
                                    isMissing: _vm.errors.missing.clientId,
                                    dynamicData: {
                                        data: [].concat( _vm.clients ),
                                        ordering: _vm.order.loading,
                                        apiValue: {
                                            label: _vm.client.name,
                                            value: _vm.client.id,
                                        },
                                    },
                                    errorOnSubmit: {
                                        show: _vm.errors.api.clientId
                                            ? true
                                            : false,
                                        messages: _vm.errors.api.clientId,
                                    },
                                    name: 'clientId',
                                    value: _vm.client.name,
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: _vm.permissions.allowFilling && ( [ '5', '6' ].includes( _vm.payload.roleId ) || _vm.clientIsRequired )
                            },"anchor":{
                                url: ("/clients/" + _vm.clientId),
                                disable: !_vm.clientId,
                                see:
                                    _vm.$store.getters.can('clients', 'see') &&
                                    _vm.clientId,
                                translationKey: 'viewProfile'
                            }}})],1)]},proxy:true}])})],1),_c('base-card',{staticClass:"user__observations",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("global.observations"))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('base-field',{class:[
                        'user__body__observations ',
                        {
                            'background--grey--light':
                                _vm.permissions.allowFilling,
                        } ],attrs:{"settings":{
                        label: {
                            class: 'field__label--hide',
                            text: _vm.$t('global.observations'),
                        },
                        input: {
                            component: 'Textarea',
                            name: 'observations',
                            id: 'observations',
                            class: 'user__body__observations__field typography--default color--default',
                            value: _vm.model.observations || '',
                            placeholder: _vm.$t('placeholders.observations'),
                            disableClass:
                                'user__body__observations__field user__body__observations__field--disable display--block',
                        },
                        isEdition: _vm.isEdition,
                        reset: _vm.reset,
                        allowFilling: _vm.permissions.allowFilling,
                    }}})]},proxy:true}])})],1),(!_vm.$route.meta.isAdd)?_c('widget-options',[(
                _vm.$store.getters.can('users', 'delete') &&
                !_vm.$store.getters.isSameUser(_vm.model.id)
            )?_c('widget-button',{attrs:{"settings":{
                action: function () { return _vm.toggleModal('deleteUser'); },
                label: 'deleteUser',
            }}}):_vm._e(),_c('widget-button',{attrs:{"settings":{
                action: function () { return _vm.toggleModal('changePassword'); },
                label: 'changePassword',
            }}})],1):_vm._e(),(_vm.modal.show)?_c('modal',{key:_vm.modal.show,attrs:{"form":{
            class: 'modal__form--action display--flex',
            settings: {
                submissionType: _vm.modal[_vm.modal.type].action,
            },
        },"customSettings":{
            color: 'red',
            button: {
                label: 'confirm',
            },
        },"executeCloseAction":!_vm.modal.loading},on:{"close":function($event){return _vm.toggleModal(_vm.modal.type)}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"modal__header"},[_vm._v(_vm._s(_vm.$t("global.confirm")))])]},proxy:true},{key:"modal__body",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t(("warning." + (_vm.modal.type))))+" ")]},proxy:true},{key:"modal__info",fn:function(){return [_c('base-button',{staticClass:"\n                    modal__content__button--negative\n                    background--transparent\n                    border--grey\n                ",class:{ disable: _vm.modal.loading },domProps:{"innerHTML":_vm._s(_vm.$t('global.cancel'))},on:{"click":function($event){return _vm.toggleModal(_vm.modal.type)}}})]},proxy:true}],null,false,2680819209)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }